import { configureStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'

import authReducer from './authSlice'
import ticketReducer from './ticketSlice'
import uiReducer from './uiSlice'

export const store = configureStore({
	reducer: {
		auth: authReducer,
		ticket: ticketReducer,
		ui: uiReducer,
	},
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Typed hooks — use these throughout the app instead of plain useDispatch/useSelector
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
